module.exports = __webpack_public_path__ + "static/img/media-wechat.20bfc25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/pc/chuangfu/media-wechat.png
// module id = 18
// module chunks = 0